let sessionExpiredHandler = null;

export function registerSessionExpiredHandler(handler) {
    sessionExpiredHandler = handler;
}

export function triggerSessionExpired() {
    if (sessionExpiredHandler) {
        sessionExpiredHandler();
        return true;
    }
    return false;
}
